import React from "react";
import { LinearProgress, Grid2 as Grid, Typography } from "@mui/material";
import { Settings } from "../../../shared/types";

export interface ThankYouProps {
  busy: boolean;
  settings: Settings;
}

export const ThankYou = ({
  busy,
  settings,
}: ThankYouProps): React.JSX.Element => {
  return (
    <Grid size={{ xs: 12 }} container spacing={2}>
      {busy && (
        <Grid size={{ xs: 12 }}>
          <LinearProgress />
        </Grid>
      )}
      {settings.thankYouDetails.markup && (
        <Grid size={{ xs: 12 }} container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <Typography
              variant="body1"
              component="div"
              dangerouslySetInnerHTML={{
                __html: settings.thankYouDetails.markup,
              }}
            ></Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};
